import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, fmtAZN } from "@/lib/api";
import { usePlay, Panel, Label, Stat } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { sfx } from "@/lib/sound";

export const KenoGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [picks, setPicks] = useState([]);
  const [table, setTable] = useState(null);
  const [res, setRes] = useState(null);
  const [shown, setShown] = useState(0);
  useEffect(() => { api.get("/games/keno/paytable").then(({ data }) => setTable(data)); }, []);

  const toggle = (n) => {
    if (busy) return;
    setRes(null);
    setPicks((p) => (p.includes(n) ? p.filter((x) => x !== n) : p.length < 10 ? [...p, n] : p));
    sfx.click();
  };
  const random = () => { if (busy) return; setRes(null); setPicks([...Array(40).keys()].map((i) => i + 1).sort(() => Math.random() - 0.5).slice(0, picks.length || 5)); };
  const go = async () => {
    setRes(null); setShown(0);
    const d = await play("/games/keno", { bet, picks });
    if (!d) return;
    setRes(d);
    d.drawn.forEach((n, i) => setTimeout(() => { setShown(i + 1); d.hits.includes(n) ? sfx.gem() : sfx.peg(); }, 200 * (i + 1)));
    setTimeout(() => finish(d), 200 * 11);
  };
  const drawn = res ? res.drawn.slice(0, shown) : [];
  const pays = table && picks.length ? Object.entries(table[picks.length]).filter(([, m]) => m > 0) : [];

  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="keno-game">
      <Panel className="order-2 lg:order-1">
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={busy} testid="keno-bet" /></div>
        <div className="grid grid-cols-2 gap-2">
          <Stat label="Seçilib" value={`${picks.length}/10`} testid="keno-pick-count" />
          <Stat label="Tutdu" value={res && shown === 10 ? res.hits.length : "-"} testid="keno-hits" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button disabled={busy} onClick={random} className="btn-ghost rounded-full py-2 text-sm" data-testid="keno-random-btn">Təsadüfi</button>
          <button disabled={busy} onClick={() => { setPicks([]); setRes(null); }} className="btn-ghost rounded-full py-2 text-sm" data-testid="keno-clear-btn">Təmizlə</button>
        </div>
        <button disabled={busy || !picks.length} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="keno-play-btn">Oyna</button>
        {pays.length > 0 && (
          <div className="space-y-1" data-testid="keno-paytable">
            <Label>Ödənişlər ({picks.length} seçim)</Label>
            {pays.map(([h, m]) => (
              <div key={h} className={`flex justify-between text-sm rounded-lg px-3 py-1 ${res && shown === 10 && res.hits.length === Number(h) ? "bg-[#FFD700] text-black font-bold" : "bg-black/40"}`}><span>{h} tutdu</span><span>x{m}</span></div>
            ))}
          </div>
        )}
      </Panel>
      <div className="machine-frame rounded-3xl p-4 sm:p-6 order-1 lg:order-2 space-y-4">
        <div className="grid grid-cols-8 gap-1.5 sm:gap-2" data-testid="keno-board">
          {[...Array(40).keys()].map((i) => {
            const n = i + 1, p = picks.includes(n), d = drawn.includes(n);
            return (
              <motion.button key={n} onClick={() => toggle(n)} animate={d ? { scale: [1, 1.2, 1] } : {}} data-testid={`keno-num-${n}`}
                className={`aspect-square rounded-xl font-display font-bold text-sm sm:text-lg transition-colors ${p && d ? "bg-emerald-500 text-black shadow-[0_0_20px_#10b981]" : d ? "bg-[#c4112f] text-white" : p ? "bg-[#D4AF37] text-black" : "bg-white/5 hover:bg-white/15 text-zinc-300"}`}>{n}</motion.button>
            );
          })}
        </div>
        <p className={`text-center font-display font-bold text-xl h-8 ${res && shown === 10 ? (res.won ? "text-emerald-300" : "text-red-300") : ""}`} data-testid="keno-result">
          {res && shown === 10 ? (res.won ? `${res.hits.length} tutdu · +${fmtAZN(res.win)}` : `${res.hits.length} tutdu · Qazanc yoxdur`) : ""}
        </p>
      </div>
    </div>
  );
};
